import { Fragment, useEffect, useState } from "react";

import { Card, Link as DSLink } from "@icg360/design-system";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "components/common/table";
import { usePolicyDetail } from "data/ss-data-hooks";
import { dateStringForState, getApiDatetimeFromRoute } from "utils";

type DocList = Array<{ label: string; createdAt: string; route: string }>;

export const AllPolicyDocs = () => {
  const { data: policyDetail } = usePolicyDetail();
  const [docs, setDocs] = useState<DocList>([]);

  useEffect(() => {
    if (policyDetail?.userDetails && policyDetail?.userDocuments) {
      const { grouped } = policyDetail.userDocuments;
      const { isCommercial } = policyDetail.userDetails;
      const flatDocs = grouped?.flat() ?? [];
      setDocs(
        flatDocs
          .reduce((result: DocList, document) => {
            const { route, label, lastUpdated, templateId } = document;
            if (
              isCommercial &&
              [
                "BOPRenewalNoticeSICSC",
                "BOPRenewalProposalSICSC",
                "BOPRenewalProposalSICLA",
                "BOPRenewalProposalSICNC",
              ].includes(templateId ?? "")
            ) {
              return result;
            }
            const hrefDate = getApiDatetimeFromRoute(route ?? "");
            const lastUpdatedDate = new Date(Number(lastUpdated));
            const createdAt =
              hrefDate > lastUpdatedDate
                ? lastUpdatedDate.toISOString()
                : hrefDate.toISOString();
            result.push({
              route: `/api/policy/${document.parentId}/${document.location}`,
              label: label ?? "",
              createdAt,
            });
            return result;
          }, [])
          .sort((a, b) => {
            if (a.createdAt < b.createdAt) {
              return 1;
            }
            if (a.createdAt > b.createdAt) {
              return -1;
            }
            return 0;
          })
      );
    }
  }, [policyDetail?.userDetails, policyDetail?.userDocuments]);

  const propertyState =
    policyDetail?.userDetails.propertyAddress?.state ?? "NJ";
  return (
    <Card title="All policy documents">
      {docs.length !== 0 ? (
        <Table>
          <TableHead>
            <TableRow>
              <TableHeader>Date</TableHeader>
              <TableHeader>Document</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {docs.map(({ label, createdAt, route }, i) => (
              <Fragment key={route + i}>
                <TableRow>
                  <TableCell>
                    {dateStringForState(createdAt, propertyState)}
                  </TableCell>
                  <TableCell>
                    <DSLink href={route} target="_blank">
                      {label}
                    </DSLink>
                  </TableCell>
                </TableRow>
              </Fragment>
            ))}
          </TableBody>
        </Table>
      ) : (
        <div>There are no policy documents available at this time.</div>
      )}
    </Card>
  );
};
